export const FORMA_PAGO_MAP = {
    '10': 'Efectivo',
    '42': 'Consignación bancaria',
    '1': 'Instrumento no definido',
    '20': 'Cheque',
    '30': 'Transferencia Crédito',
    '31': 'Transferencia Débito',
    '45': 'Transferencia Crédito Bancario',
    '47': 'Transferencia Débito Bancaria',
    '48': 'Tarjeta Crédito',
    '49': 'Tarjeta Débito',
    ZZZ: 'Acuerdo mutuo',
};

export function getFormaPagoTexto(formaPago) {
    if (formaPago === null || formaPago === undefined || formaPago === '') return 'N/A';
    const key = String(formaPago).trim();
    return FORMA_PAGO_MAP[key] || formaPago;
}

export function camposProveedorBasicosDesdeRegistro(origen) {
    if (!origen) {
        return { tipoDocumento: '', numeroDocumento: '' };
    }
    return {
        tipoDocumento: origen.tipo_documento || origen.proveedor_tipo_documento || '',
        numeroDocumento: origen.numero_documento || origen.proveedor_documento || '',
    };
}

export function camposProveedorBasicosDesdeLista(proveedores, proveedorId) {
    const p = proveedores.find((x) => String(x.id) === String(proveedorId));
    return camposProveedorBasicosDesdeRegistro(p);
}

const ESTILO_ENCABEZADO = {
    font: { bold: true },
    alignment: { horizontal: 'center', vertical: 'center' },
    fill: { patternType: 'solid', fgColor: { rgb: 'E5E7EB' } },
};

function aplicarEstiloEncabezado(ws, XLSX) {
    if (!ws['!ref']) return;
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let col = range.s.c; col <= range.e.c; col += 1) {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
        if (!ws[cellRef]) continue;
        ws[cellRef].s = ESTILO_ENCABEZADO;
    }
}

export function descargarExcelXlsx(filas, sheetName, nombreArchivo) {
    if (!filas.length) return;
    descargarExcelXlsxHojas([{ name: sheetName, filas }], nombreArchivo);
}

export function descargarExcelXlsxHojas(hojas, nombreArchivo) {
    const hojasValidas = (hojas || []).filter((h) => h.filas && h.filas.length > 0);
    if (!hojasValidas.length) return;

    import('xlsx-js-style').then((mod) => {
        const XLSX = mod.default || mod;
        const wb = XLSX.utils.book_new();
        hojasValidas.forEach((hoja) => {
            const ws = XLSX.utils.json_to_sheet(hoja.filas);
            aplicarEstiloEncabezado(ws, XLSX);
            XLSX.utils.book_append_sheet(wb, ws, (hoja.name || 'Hoja').slice(0, 31));
        });
        const fileName = nombreArchivo.endsWith('.xlsx') ? nombreArchivo : `${nombreArchivo}.xlsx`;
        XLSX.writeFile(wb, fileName);
    }).catch((error) => {
        console.error('Error exportando Excel:', error);
        alert('No se pudo generar el archivo Excel');
    });
}

function base64DesdeChart(chartRef) {
    const chart = chartRef?.current;
    if (!chart) return null;
    if (typeof chart.toBase64Image === 'function') {
        return chart.toBase64Image('image/png', 1);
    }
    if (chart.canvas && typeof chart.canvas.toDataURL === 'function') {
        return chart.canvas.toDataURL('image/png', 1);
    }
    return null;
}

function agregarHojaTablaExcelJS(ws, filas) {
    if (!filas.length) return;
    const headers = Object.keys(filas[0]);
    const headerRow = ws.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE5E7EB' } };
    });
    filas.forEach((fila) => ws.addRow(headers.map((h) => fila[h])));
    ws.columns.forEach((col) => {
        let max = 10;
        col.eachCell({ includeEmpty: false }, (cell) => {
            const len = cell.value ? String(cell.value).length : 0;
            if (len > max) max = len;
        });
        col.width = Math.min(max + 2, 50);
    });
}

/**
 * Excel con tablas y gráficos como imágenes PNG embebidas.
 * @param {{ hojas: {name:string, filas:object[]}[], graficos?: {titulo:string, base64:string}[], nombreArchivo: string }} opts
 */
export function descargarExcelConHojasYGraficos({ hojas, graficos, nombreArchivo }) {
    const hojasValidas = (hojas || []).filter((h) => h.filas && h.filas.length > 0);
    const graficosValidos = (graficos || []).filter((g) => g.base64);

    if (!hojasValidas.length && !graficosValidos.length) return;

    import('exceljs').then(async (mod) => {
        const ExcelJS = mod.default || mod;
        const wb = new ExcelJS.Workbook();

        if (graficosValidos.length > 0) {
            const wsGraf = wb.addWorksheet('Gráficos');
            let filaActual = 1;
            graficosValidos.forEach((grafico) => {
                wsGraf.getCell(filaActual, 1).value = grafico.titulo;
                wsGraf.getCell(filaActual, 1).font = { bold: true, size: 12 };
                filaActual += 1;
                const raw = grafico.base64.includes(',')
                    ? grafico.base64.split(',')[1]
                    : grafico.base64;
                const imageId = wb.addImage({ base64: raw, extension: 'png' });
                wsGraf.addImage(imageId, {
                    tl: { col: 0, row: filaActual - 1 },
                    ext: { width: 520, height: 300 },
                });
                filaActual += 20;
            });
            wsGraf.getColumn(1).width = 80;
        }

        hojasValidas.forEach((hoja) => {
            const ws = wb.addWorksheet((hoja.name || 'Hoja').slice(0, 31));
            agregarHojaTablaExcelJS(ws, hoja.filas);
        });

        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        const fileName = nombreArchivo.endsWith('.xlsx') ? nombreArchivo : `${nombreArchivo}.xlsx`;
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
    }).catch((error) => {
        console.error('Error exportando Excel con gráficos:', error);
        alert('No se pudo generar el archivo Excel');
    });
}

export { base64DesdeChart };

export function descargarCsvReporte(filas, nombreArchivo) {
    if (!filas.length) return;
    const headers = Object.keys(filas[0]);
    const csvEscape = (valor) => `"${String(valor ?? '').replace(/"/g, '""')}"`;
    const csvContent = [
        headers.map(csvEscape).join(','),
        ...filas.map((row) => headers.map((h) => csvEscape(row[h])).join(',')),
    ].join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = nombreArchivo.endsWith('.csv') ? nombreArchivo : `${nombreArchivo}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
}
